@file:OptIn(ExperimentalJsExport::class)

package nl.astraeus.midi.audio

import org.khronos.webgl.Float32Array
import org.w3c.dom.MessageEvent

object VstChipWorklet : AudioNode(
  "/vst-chip-worklet.js",
  "vst-chip-processor"
) {
  var waveform: Int = 0
    set(value) {
      field = value
      postMessage("waveform\n$value")
    }
  var midiChannel = 0
    set(value) {
      check(value in 0..15) {
        "Midi channel must be between 0 and 15."
      }
      field = value
      postMessage("set_channel\n${midiChannel}")
    }
  var volume = 0.75
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 7, (value * 127).toInt()
      )
    }
  var dutyCycle = 0.5
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x47, (value * 127).toInt()
      )
    }
  var fmModFreq = 1.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x40, (value * 127).toInt()
      )
    }
  var fmModAmp = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x41, (value * 127).toInt()
      )
    }
  var amModFreq = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x42, (value * 127).toInt()
      )
    }
  var amModAmp = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x43, (value * 127).toInt()
      )
    }
  var feedback = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x50, (value * 127).toInt()
      )
    }
  var delay = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x4e, (value * 127).toInt()
      )
    }
  var delayDepth = 0.0
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x4f, (value * 127).toInt()
      )
    }

  var attack = 0.1
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x49, (value * 127).toInt()
      )
    }
  var decay = 0.2
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x4b, (value * 127).toInt()
      )
    }
  var sustain = 0.5
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x46, (value * 127).toInt()
      )
    }
  var release = 0.2
    set(value) {
      field = value
      super.postMessage(
        0xb0 + midiChannel, 0x48, (value * 127).toInt()
      )
    }

  var recording: Float32Array? = null

  override fun onMessage(message: MessageEvent) {
    //console.log("Message from worklet: ", message)

    val data = message.data
    if (data is Float32Array) {
      this.recording = data
    }
  }

  fun postDirectlyToWorklet(msg: Any) {
    super.postMessage(msg)
  }

  /*  override fun postMessage(msg: Any) {
      if (msg is ByteArray) {
        val tmm = TimedMidiMessage(msg)
        val byte1 = tmm.midi[0]

        if (byte1.toInt() and 0xf0 == 0xb0) {
          handleIncomingMidi(tmm.midi[1], tmm.midi[2])
        }
      }
      super.postMessage(msg)
    }*/

  override fun postMessage(vararg msg: Int) {
    println("postMessage ${msg.size} bytes")
    /*    if (
          msg.size == 3
          && (msg[0] and 0xf == midiChannel)
          && (msg[0] and 0xf0 == 0xb0)
        ) {
          val knob = msg[1]
          val value = msg[2]

          handleIncomingMidi(knob.toByte(), value.toByte())
        }*/

    super.postMessage(msg)
  }

  private fun handleIncomingMidi(knob: Byte, value: Byte) {
    println("Incoming knob: $knob, value: $value")
    when (knob) {
      0x46.toByte() -> {
        volume = value / 127.0
      }

      0x4a.toByte() -> {
        dutyCycle = value / 127.0
      }

      0x40.toByte() -> {
        fmModFreq = value / 127.0
      }

      0x41.toByte() -> {
        fmModAmp = value / 127.0
      }

      0x42.toByte() -> {
        amModFreq = value / 127.0
      }

      0x43.toByte() -> {
        amModAmp = value / 127.0
      }
    }
  }

  fun load(patch: PatchDTO) {
    waveform = patch.waveform
    midiChannel = patch.midiChannel
    volume = patch.volume
    dutyCycle = patch.dutyCycle
    fmModFreq = patch.fmModFreq
    fmModAmp = patch.fmModAmp
    amModFreq = patch.amModFreq
    amModAmp = patch.amModAmp
    attack = patch.attack
    decay = patch.decay
    sustain = patch.sustain
    release = patch.release
    delay = patch.delay
    delayDepth = patch.delayDepth
    feedback = patch.feedback
  }

  fun save(): PatchDTO {
    return PatchDTO(
      waveform = waveform,
      midiChannel = midiChannel,
      volume = volume,
      dutyCycle = dutyCycle,
      fmModFreq = fmModFreq,
      fmModAmp = fmModAmp,
      amModFreq = amModFreq,
      amModAmp = amModAmp,
      attack = attack,
      decay = decay,
      sustain = sustain,
      release = release,
      delay = delay,
      delayDepth = delayDepth,
      feedback = feedback
    )
  }

}
